import React, { useState, useEffect, useContext } from "react";
import { ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import CryptoJS from "crypto-js";
import { project_url, admin_string, secretPass } from "../../constants/Data";

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/*##########################################################################
## Function    : Logout
## Description : logout user
## Author      : RR
## Date        : 2022/03/12
##########################################################################*/
export default function Logout() {
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const role = CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(CryptoJS.enc.Utf8);
  useEffect(
    () => {
	      localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("role");
        localStorage.removeItem("email");
        localStorage.removeItem("firstName");
        localStorage.removeItem("lastName");
        localStorage.removeItem("tenantId");
        localStorage.removeItem("tenantName");
        localStorage.removeItem("clientId");
        localStorage.removeItem("clientName");
        localStorage.removeItem("applicantId");
        client.removeHeader("Authorization");
      navigate(`${project_url}/signin`);
    },
    [localStorage]
  );

  /////////////////////////////////////////////////////////////////////
  return (
    <>
    <title> APIE | Log Out</title>

    <h2>
      You are logged out. You will be redirected to login page.
    </h2>
    </>
  );
}
